//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import PlanFilterModal from '@/modules/plan/components/plan-filter-modal.vue';
import PlanListTable from '@/modules/plan/components/plan-list-table.vue';

import { mapGetters } from 'vuex';
import { PlanPermissions } from '@/modules/plan/plan-permissions';
// import { i18n } from '@/i18n';

export default {
  name: 'app-plan-list-page',

  components: {
    // [PlanFilterModal.name]: PlanFilterModal,
    [PlanListTable.name]: PlanListTable,
  },

  data() {
    return {
      dialogVisible: true,
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      is_screen_xs: 'layout/is_screen_xs',
      currentLanguageCode: 'layout/currentLanguageCode',
    }),
    hasPermissionToCreate() {
      return new PlanPermissions(this.currentUser).create;
    },
  },
  methods: {
    i18n(key, args) {
      return this.$t(key, args);
    },
    doOpenModal() {
      this.dialogVisible = true;
    },
    onModalClose() {
      this.dialogVisible = false;
    },
  },
};
